import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";

export const useGetAssignedCFIs = (dealerCompanyID: number) => {
    const { data, isLoading } = useQuery({
        queryKey: ['assigned-cfis', dealerCompanyID],
        queryFn: async () => await apiClient.get('company/assigned-cfis') as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
